import { Component, Input, OnInit } from '@angular/core';
import { OnyxSummaryEvent } from '../../models/event.summary';
import { MenuStore } from '../../../menus/service/menu.store';
import { EnvironmentConfiguration } from '../../../environment/services/environment.configuration';
import { PaymentStatusUtils } from '../../utils/payment-status-utils';
import { Page } from '../../../shared/models/page';
import { Constants } from 'app/shared/constants';
import { CommonDataStore } from '../../service/common-data/common-data.store';
import { Observable } from 'rxjs/Observable';
import { DropdownItem } from '../../models/dropdown-item';
import { EventStatusInfo } from '../../../shared/models/event-status-info';
import { VendorPaymentSummary } from '../../models/vendor-payment-summary';
import { GroupPayConfigStore } from '../../service/grouppay-config.store';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { PaymentStatus } from 'app/event/models/payment-status.enum';

@Component({
  selector: 'pioneer-event-list-multi-vendor-table',
  templateUrl: './event-list-multi-vendor.component.html',
  styleUrls: ['./event-list-multi-vendor.component.css']
})
export class EventListMultiVendorComponent implements OnInit {

  @Input()
  events: Page<OnyxSummaryEvent>;

  public searchText: string;

  public imagesUrl= '';

  private _isCollapsed = false;

  public isOoivEnabled: boolean;


  isAgencyUser: boolean;

  constructor(private environment: EnvironmentConfiguration,
              private menuStore: MenuStore,
              private _commonDataStore: CommonDataStore,
              private groupPayConfigStore: GroupPayConfigStore,
              private authenticationStore: AuthenticationStore) {
  }

  ngOnInit() {
    this.menuStore.setPageHeader('EVENTS.TITLE', false);
    this.searchText = '';
    this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;

    this.groupPayConfigStore.isOoivEnabled(null, null, null)
      .subscribe(ooivEnabled => {
        this.isOoivEnabled = ooivEnabled;
      });

    this.isAgencyUser = this.authenticationStore.isAgencyUser();
  }

  get commonDataStore(): CommonDataStore {
    return this._commonDataStore;
  }

  get eventCount(): number {
    return this.events.totalElements;
  }

  get eventCountForTranslate(): Object {
    return {
      eventCount: this.eventCount
    };
  }

  getPaymentAmount(status: string, amount: string): number {
    if (PaymentStatusUtils.isError(<any>status)) {
      return 0;
    } else {
      return Number(amount);
    }
  }

  getTotalEventPaymentAmount(eventSummary: OnyxSummaryEvent): number {
    return this.getPaymentAmount(eventSummary.prepayStatus, eventSummary.prepaymentAmount)
      + this.getPaymentAmount(eventSummary.payStatus, eventSummary.paymentAmount)
      + this.getPaymentAmount(eventSummary.payStatus, eventSummary.taxAmount);
  }

  getTotalVendorPaymentAmountByStatus(paymentSummary: VendorPaymentSummary): number {
    if (PaymentStatusUtils.isNoTotalPaid(<any>paymentSummary.payStatus)) {
      return this.getPaymentAmount(paymentSummary.prepayStatus, paymentSummary.prepaymentAmount);
    } else {
      return this.getTotalVendorPaymentAmount(paymentSummary);
    }
  }

  getTotalVendorPaymentAmount(paymentSummary: VendorPaymentSummary): number {
    return this.getPaymentAmount(paymentSummary.prepayStatus, paymentSummary.prepaymentAmount)
      + this.getPaymentAmount(paymentSummary.payStatus, paymentSummary.paymentAmount)
      + this.getPaymentAmount(paymentSummary.payStatus, paymentSummary.taxAmount);
  }

  getEstimatedDue(dueAmount: string): number {
    return Math.max(Number(dueAmount), 0);
  }

  getEventNameLine1(name: string): string {
    if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
      return name.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
    } else {
      return name;
    }
  }

  getEventNameLine2(name: string): string {
    if (name.length > Constants.EVENTS_NAME_MAX_SIZE) {
      const line2: string = name.substring(Constants.EVENTS_NAME_MAX_SIZE);
      if (line2.length > Constants.EVENTS_NAME_MAX_SIZE) {
        return line2.substring(0, Constants.EVENTS_NAME_MAX_SIZE);
      } else {
        return line2;
      }
    } else {
      return null;
    }
  }

  getCountryName(countryCode: string): Observable<DropdownItem> {
    return this.commonDataStore.getCountry(countryCode);
  }

  public onCardExpandClicked(event: Event, eventId: number, expanded: boolean): void {
    event.preventDefault();
    this.events.content.filter(ev => ev.eventId === eventId).forEach(x => {
      x.isExpanded = expanded;
    });
  }

  public getStatusClasses(status: string): string {

    const eventStatusInfo: EventStatusInfo = new EventStatusInfo(status);

    if (eventStatusInfo.isPaid()) {
      return 'badge-success';
    } else if (eventStatusInfo.isUnpaid()) {
      return 'badge-danger';
    } else if (eventStatusInfo.isProcessing()) {
      return 'badge-warning';
    } else if (eventStatusInfo.isCancelled()) {
      return 'badge-secondary';
    } else {
      return '';
    }

  }

  getPaymentStatus(status: PaymentStatus) {
    return PaymentStatusUtils.getAwePaymentStatus(status, this.authenticationStore.isAgencyUser());
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/event-list/event-list-multi-vendor-table/event-list-multi-vendor.component.ts